import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Paper,
  Typography,
  Button,
  Box,
  TextField,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Dialog,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { parseISO } from "date-fns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import QuestionStepper from "../../components/QuestionStepper.jsx";
import useCaseTypesList from "../../hooks/useCaseTypesList.js";
import { getCaseQuestionsByType } from "../../api/caseQuestions.js";
import {
  createCase,
  postCheckApproval,
  postQuestionsAnswers,
} from "../../api/cases.js";
import useSnackbar from "../../hooks/useSnackbar.js";
import useErrorHandler from "../../hooks/useErrorHandler.js";

const emptyCaseData = {
  description: "",
  title: "",
  start_date: "",
  end_date: "",
  status: "INITIAL",
  type: "",
};
export default function NewCase() {
  const navigate = useNavigate();
  const snackbar = useSnackbar();
  const errorHandler = useErrorHandler();

  const { data: user } = useSelector((state) => state.user);

  const [data, setData] = useState(emptyCaseData);
  const [caseQuestions, setCaseQuestion] = useState([]);
  const [showQuestionDialog, setShowQuestionDialog] = useState(false);
  const [questionsDone, setQuestionsDone] = useState(false);

  useEffect(() => {
    if (/^admin|registrar$/i.test(user.roles)) {
      setQuestionsDone(true);
    }
  }, [user.roles]);

  const onInputChange = ({ target }) => {
    setData((prev) => ({ ...prev, [target.name]: target.value }));
  };

  const { caseTypeList } = useCaseTypesList();

  const onCaseTypeChange = async ({ target }) => {
    setData((prev) => ({ ...prev, [target.name]: target.value }));

    if (!/^admin|registrar$/i.test(user.roles)) {
      onCheckApproval(target.value);
      // try {
      //   if (!target.value) return;
      //   // api call
      //   const { data } = await getCaseQuestionsByType(user.token, target.value);
      //   setCaseQuestion(data.data);
      //   setShowQuestionDialog(true);
      //   setQuestionsDone(false);
      // } catch (err) {
      //   console.log(err);
      // }
    }
  };

  const getQuestionData = async (caseType) => {
    try {
      if (!caseType) return;
      // api call
      const { data } = await getCaseQuestionsByType(user.token, caseType);
      setCaseQuestion(data.data);
      setShowQuestionDialog(true);
      setQuestionsDone(false);
    } catch (err) {
      errorHandler(err);
      console.log(err);
    }
  };

  const onCreateFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await createCase(user.token, {
        ...data,
        // interview: /^admin$/i.test(user.roles) ? [] : questionsDone,
      });
      snackbar.showSuccess(res.data.msg);
      navigate("/cases");
    } catch (err) {
      errorHandler(err);
    }
  };
  const onCheckApproval = async (caseType) => {
    try {
      const { data } = await postCheckApproval(user.token, {
        user_id: user.id,
        case_type: caseType,
      });
      checkStatus(data.approved, caseType);
      // snackbar.showSuccess();
      // navigate("/cases");
    } catch (err) {
      errorHandler(err);
    }
  };

  const checkStatus = (status, caseType) => {
    switch (status) {
      case "submitted": {
        return snackbar.showSuccess(
          "your request is pending for approval. Please wait for sometime."
        );
      }

      case "approved": {
        return setQuestionsDone(true);
      }

      case "Not submitted yet": {
        return getQuestionData(caseType);
      }

      case "rejected": {
        snackbar.showSuccess(
          "your request to create case has been rejected. Please fill the questionnaire again."
        );
        return getQuestionData(caseType);
      }

      default:
        break;
    }
  };

  return (
    <>
      {/* <Box mb={2} display="flex" justifyContent="flex-end">
        <Link to="/cases">
          <Button variant="contained" size="small" color="secondary">
            Cancel
          </Button>
        </Link>
      </Box> */}
       <Paper className="odr-card">
        <Box
          display="flex"
          justifyContent="space-between"
          className="odr-card-header"
        >
          <Typography className="heading-title">Case Details</Typography>
        </Box>

        <Box px={2} pb={2} component="form" onSubmit={onCreateFormSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6} lg={4}>
              <FormControl required fullWidth size="small" varaint="outlined">
                <InputLabel id="demo-simple-select">Case Type</InputLabel>
                <Select
                  variant="outlined"
                  required
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="type"
                  value={data.type}
                  label="Case Type"
                  onChange={onCaseTypeChange}
                >
                  <MenuItem value="">Select</MenuItem>
                  {caseTypeList.map((t, i) => (
                    <MenuItem key={i} value={t}>
                      {t}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <br />
          {questionsDone ? (
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={4}>
                <TextField
                  value={data.title}
                  label="Title"
                  onChange={onInputChange}
                  size="small"
                  fullWidth
                  variant="outlined"
                  name="title"
                  required
                />
              </Grid>
              <Grid item xs={12} md={6} lg={8}>
                <TextField
                  value={data.description}
                  label="Description"
                  onChange={onInputChange}
                  size="small"
                  fullWidth
                  variant="outlined"
                  name="description"
                  required
                />
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="Start Date"
                    required
                    // minDateTime={parseISO(new Date().toISOString())}
                    value={parseISO(data.start_date)}
                    onChange={(newValue) => {
                      onInputChange({
                        target: {
                          name: "start_date",
                          value: newValue.toISOString(),
                        },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        required
                        {...params}
                        fullWidth
                        size="small"
                        variant="outlined"
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="End Date"
                    minDate={data.start_date}
                    value={parseISO(data.end_date)}
                    onChange={(newValue) => {
                      onInputChange({
                        target: {
                          name: "end_date",
                          value: newValue.toISOString(),
                        },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        size="small"
                        variant="outlined"
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <FormControl required fullWidth size="small" varaint="outlined">
                  <InputLabel id="demo-simple-select-s">Status</InputLabel>
                  <Select
                    variant="outlined"
                    required
                    labelId="demo-simple-select-label-s"
                    id="demo-simple-select-s"
                    name="status"
                    value={data.status}
                    label="Status"
                    onChange={onInputChange}
                  >
                    <MenuItem value="INITIAL">Initial</MenuItem>
                    <MenuItem value="OPEN">Open</MenuItem>
                    <MenuItem value="Closed">Closed</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Box display="flex" columnGap={1} justifyContent="flex-end">
                  <Link to="/cases">
                    <Button
                      variant="outlined"
                      size="large"
                      color="secondary"
                      className="black-border-button"
                    >
                      Cancel
                    </Button>
                  </Link>

                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    size="large"
                    className="blue-button"
                    disabled={/^trial_user$/i.test(user.roles) ? true : false}
                  >
                    Create
                  </Button>
                </Box>
              </Grid>
            </Grid>
          ) : (
            <></>
          )}
        </Box>
      </Paper>

      <QuestionDialog
        open={showQuestionDialog}
        setOpen={setShowQuestionDialog}
        questions={caseQuestions}
        allDone={setQuestionsDone}
        caseType={data.type}
      />
    </>
  );
}

function QuestionDialog({ open, setOpen, questions = [], allDone, caseType }) {
  const snackbar = useSnackbar();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const errorHandler = useErrorHandler();
  const [answers, setAnswers] = useState(null);
  const { data: user } = useSelector((state) => state.user);
  const handleAnswerChange = (id, value, multiple) => {
    let newValue;
    if (multiple) {
      if (answers[id]?.includes(value))
        newValue = answers[id].filter((v) => v !== value);
      else newValue = [...answers[id], value];
    } else {
      newValue = value;
    }
    setAnswers((prev) => ({
      ...prev,
      [id]: newValue,
    }));
  };

  const handleDone = () => {
    const answeredQuestionsCount = Object.keys(answers).filter((k) =>
      Boolean(answers[k].length)
    ).length;
    if (answeredQuestionsCount === questions.length) {
      let interview = questions.map((q) => ({
        case_question_id: q.id,
        answer: answers[q.id].toString(),
        user_id: user.id,
        case_type: caseType,
      }));
      let combinedMap = {
        questionAnswers: interview,
      };
      onQuestionAnswerSubmit(combinedMap, interview);
      // console.log("question done combined----", combinedMap);
      // return;
      // allDone(interview);
      // setOpen(false);
    } else {
      snackbar.showInfo("Answering All Questions is Compulsory");
    }
  };
  const onQuestionAnswerSubmit = async (newdata, interview) => {
    setLoader(true);
    try {
      const { data } = await postQuestionsAnswers(user.token, newdata);
      snackbar.showSuccess(data.msg);
      // allDone(interview);
      setOpen(false);
      setLoader(false);
      navigate("/cases");
    } catch (err) {
      errorHandler(err);
      setLoader(false);
      setOpen(false);
    }
  };

  useEffect(() => {
    if (questions.length) setAnswers(getAnswerTemplate(questions));
  }, [questions]);

  return (
    <Dialog open={open} onClose={() => {}} fullWidth>
      <QuestionStepper
        loader={loader}
        questions={questions}
        answers={answers}
        onAnswerChange={handleAnswerChange}
        onCancel={() => {
          setOpen(false);
        }}
        onDone={handleDone}
      />
    </Dialog>
  );
}

function getAnswerTemplate(questions = []) {
  let temp = {};
  questions.forEach((q) => {
    if (q.multiple) temp[q.id] = [];
    else temp[q.id] = "";
  });
  return temp;
}
